import { createSlice } from '@reduxjs/toolkit';
import {
  GET_RECIPIENTS
} from "../constants/constants";

const initialState = {
  recipients: [],
  count: 0,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(GET_RECIPIENTS, (state, action) => {
      state.recipients = action.data.recipients;
      state.count = action.data.total;
    });
  }
});

export default messagesSlice.reducer;
